// extracted by mini-css-extract-plugin
module.exports = {"cheveron":"SideMenuChevron_cheveron__1BIDH","flipVertical":"SideMenuChevron_flipVertical__3Lime"};